import React from "react";
import Breadcrumb from "../../../common/components/Breadcrumb";
import AccountSettingForm from "../containers/AccountSettingForm";
import PasswordForm from "../containers/PasswordForm";
import EDECForm from "../containers/EDECForm";
import { withPermissions } from "../../../layout/Permissions";
import { PERMISSION_USER } from "../constants/permissions";
import { useEffect } from "react";

const UserSetting = ({ localEDECIntegration, getLocalEDECIntegration }) => {
  useEffect(() => {
    getLocalEDECIntegration();
  }, [getLocalEDECIntegration]);

  return (
    <>
      <Breadcrumb title="Paramètres du compte"></Breadcrumb>
      <div className="content-body mt-2">
        <div className="row justify-content-center">
          <div className="col-12 col-md-10 col-xl-7">
            <div className="card">
              <div className="card-content">
                <div className="card-body">
                  <AccountSettingForm />
                  <div className="dropdown-divider my-2" />
                  <PasswordForm />
                  {localEDECIntegration &&
                    localEDECIntegration.data &&
                    localEDECIntegration?.data?.[0] &&
                    localEDECIntegration?.data?.[0]?.value &&
                    localEDECIntegration.data[0].value !== "" &&
                    localEDECIntegration.data[1].value !== "" && (
                      <>
                        <div className="dropdown-divider my-2" />
                        <EDECForm />
                      </>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withPermissions(UserSetting, PERMISSION_USER);
